import { KNOWN_PERIODS } from "./periodConstants";

const PERIOD_LABEL_KEYS = {
  [KNOWN_PERIODS.MONTHLY]: "plans_period_monthly",
  [KNOWN_PERIODS.QUARTERLY]: "plans_period_quarterly",
  [KNOWN_PERIODS.YEARLY]: "plans_period_yearly"
};

const PERIOD_TOGGLE_LABEL_KEYS = {
  [KNOWN_PERIODS.MONTHLY]: "lp_plan-table_monthly_toggle-select_label",
  [KNOWN_PERIODS.QUARTERLY]: "lp_plan-table_quarterly_toggle-select_label",
  [KNOWN_PERIODS.YEARLY]: "lp_plan-table_yearly_toggle-select_label"
};

const BILLING_UNIT_LABEL_KEYS = {
  [KNOWN_PERIODS.MONTHLY]: "month",
  [KNOWN_PERIODS.QUARTERLY]: "quarter",
  [KNOWN_PERIODS.YEARLY]: "year"
};

/**
 * Translation key for period suffix on plan price (e.g. "/ month").
 * @param {number} period
 * @returns {string|null}
 */
export const getPeriodLabelKey = period => PERIOD_LABEL_KEYS[period] ?? null;

/**
 * Translation key for period toggle button label.
 * @param {number} period
 * @returns {string|null}
 */
export const getPeriodToggleLabelKey = period =>
  PERIOD_TOGGLE_LABEL_KEYS[period] ?? null;

/**
 * Translation key for settings billing unit (year / quarter / month).
 * Unknown non-yearly periods fall back to "month".
 * @param {number} period
 * @returns {string}
 */
export const getBillingUnitLabelKey = period => {
  if (period === KNOWN_PERIODS.YEARLY) {
    return BILLING_UNIT_LABEL_KEYS[KNOWN_PERIODS.YEARLY];
  }

  if (period === KNOWN_PERIODS.QUARTERLY) {
    return BILLING_UNIT_LABEL_KEYS[KNOWN_PERIODS.QUARTERLY];
  }

  return BILLING_UNIT_LABEL_KEYS[KNOWN_PERIODS.MONTHLY];
};
